import { GeneralService } from 'src/app/services/general.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { Observable } from 'rxjs';
import {
  DropDownListDTO,
  DropDownListSiteRecebimentoDTO,
} from 'src/app/entity/dto/dropdownlist.component';
import { FormularioService } from 'src/app/services/formulario.service';
import { NotificationService } from 'src/app/services/notification.service';
import { eSiteType } from 'src/app/entity/enum/enum-site-type';
import { eAreaType } from 'src/app/entity/enum/enum-area-type';
import { ActivatedRoute } from '@angular/router';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-cd001-card-limpeza-III',
  templateUrl: './cd001-card-limpeza-III.component.html',
})
export class Cd001CardLimpezaIIIComponent
  extends GeneralComponent
  implements OnInit {
  public formulario?: FormGroup;
  public listSiteRecebimento?: Array<DropDownListSiteRecebimentoDTO> =
    new Array<DropDownListSiteRecebimentoDTO>();
  public listSiteOrigem?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

  public filteredOptionsSiteRecebimento: Observable<
    DropDownListSiteRecebimentoDTO[]
  >;
  public filteredOptionsSiteOrigem: Observable<DropDownListDTO[]>;
  @Output() mkCalc = new EventEmitter();

  area: string = eAreaType.commercial;
  isBasic: boolean = false;

  // tslint:disable-next-line: max-line-length
  constructor(
    protected formularioService: FormularioService,
    protected formBuilder: FormBuilder,
    protected notificationService: NotificationService,
    protected generalService: GeneralService,
    private route: ActivatedRoute
  ) {
    super('Medição da Fração de Descarte da Pré Limpeza', false);
    if (this.isComercial) {
      this.formulario = this.formBuilder.group({
        peso_amostra_dez_segundos_kg: [null, []],
        peso_amostra_trinta_segundos_g: [null, []],
        peso_fracao_analise_g: [null, []],
        peso_semente_boa_descarte_g: [null, []],
        descarte_total_pre_limpeza_prc: [null, []],
        perda_semente_boa_descarte_prc: [null, []],
        perda_descarte_prc: [null, []],
        // total_defeitos_prc: [null, []],
        // total_defeitos_g: [null, []],
        // peso_hectolitrico_fracao_boa: [null, []],
        //  peso_hectolitrico_fracao_descarte: [null, []],
        //  diferenca_peso_hectolitrico: [null, []],
        peso_pre_pos_succsao: [null, []],
        peso_topo_fundo_30s: [null, []],
        descarte_kg_h: [null, []]
      });
    }
    else {

      this.formulario = this.formBuilder.group({
        peso_amostra_dez_segundos_kg: [null, []],
        peso_amostra_trinta_segundos_g: [null, []],
        peso_fracao_analise_g: [null, []],
        peso_semente_boa_descarte_g: [null, []],
        descarte_total_pre_limpeza_prc: [null, []],
        perda_semente_boa_descarte_prc: [null, []],
        perda_descarte_prc: [null, []],
        // total_defeitos_prc: [null, []],
        // total_defeitos_g: [null, []],
        // peso_hectolitrico_fracao_boa: [null, []],
        //  peso_hectolitrico_fracao_descarte: [null, []],
        //  diferenca_peso_hectolitrico: [null, []],
        peso_pre_pos_succsao: [null, []],
        peso_topo_fundo_30s: [null, []],
        descarte_kg_h: [null, []]
      });
    }
  }

  public async ngOnInit(): Promise<void> {
    this.getArea();
    this.formChanges();
  }

  public changeCollapse(): void {
    this.collapseCard = this.collapseCard ? false : true;
  }

  public hasErrorFormControl(campoFormulario?: AbstractControl): string {
    return this.formularioService.hasErrorFormControl(campoFormulario);
  }

  public async makeCalculations(): Promise<void> {
    this.mkCalc.emit();
  }

  getArea = () => {
    this.route.paramMap.subscribe((paramMap) => {
      this.area = paramMap.get('area');
    });
  };

  formChanges = () => {
    switch (this.area) {
      case eAreaType.basic:
        this.isBasic = true;
        this.formulario.controls.peso_semente_boa_descarte_g.disable();
        //   this.formulario.controls.total_defeitos_g.disable();
        break;
      default:
        this.isBasic = false;
        this.formulario.controls.peso_semente_boa_descarte_g.enable();
        //   this.formulario.controls.total_defeitos_g.enable();
        break;
    }
  };

}
